import React from "react";
import { Container, Typography, List, ListItem, ListItemText, Divider } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <Container sx={{pt:20, pb:10}}  >
      <Typography variant="h4" gutterBottom>
        Privacy Policy
      </Typography>
      <Typography variant="body1" paragraph>
        Keel Info Solution is committed to protecting the privacy and security of your information.
        This Privacy Policy explains how we collect, use, share, and safeguard your information when you use our application, Spot My Team ("the App"), and our associated services.
      </Typography>
      <Typography variant="body1" paragraph>
        By accessing or using the App, you agree to the terms outlined in this Privacy Policy.
      </Typography>
      
      <Divider sx={{ my: 2 }} />
      <Typography variant="h5" gutterBottom>
        1. Information We Collect
      </Typography>
      <List>
        <ListItem>
          <ListItemText primary="Personal Information" secondary="Name, Email address, Phone number, Address information" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Device and Usage Information" secondary="Device identifiers (e.g., IP address, device type), Location data, Log data" />
        </ListItem>
        <ListItem>
          <ListItemText primary="Team and Activity Data" secondary="Attendance records, Real-time location updates, Project progress, Messages exchanged" />
        </ListItem>
      </List>
      
      <Divider sx={{ my: 2 }} />
      <Typography variant="h5" gutterBottom>
        2. How We Use Your Information
      </Typography>
      <List>
        <ListItem><ListItemText primary="To Provide Services" secondary="Facilitate core features such as location tracking, attendance management, and project monitoring." /></ListItem>
        <ListItem><ListItemText primary="To Improve the App" secondary="Analyze user behavior to enhance functionality, usability, and performance." /></ListItem>
        <ListItem><ListItemText primary="To Communicate with You" secondary="Send notifications, updates, and relevant information." /></ListItem>
      </List>
      
      <Divider sx={{ my: 2 }} />
      <Typography variant="h5" gutterBottom>
        3. How We Share Your Information
      </Typography>
      <Typography variant="body1" paragraph>
        We do not sell or rent your personal information. However, we may share your data in the following circumstances:
      </Typography>
      <List>
        <ListItem><ListItemText primary="With Your Consent" secondary="When you explicitly agree to share information." /></ListItem>
        <ListItem><ListItemText primary="With Authorized Users" secondary="Data related to team activity and progress is shared within your organization." /></ListItem>
        <ListItem><ListItemText primary="With Service Providers" secondary="Third-party vendors who assist with analytics, hosting, or technical support." /></ListItem>
      </List>
      
      <Divider sx={{ my: 2 }} />
      <Typography variant="h5" gutterBottom>
        4. Data Security
      </Typography>
      <Typography variant="body1" paragraph>
        We prioritize the security of your data and implement industry-standard measures to protect against unauthorized access, loss, or misuse. However, no method of transmission or storage is 100% secure.
      </Typography>
      
      <Divider sx={{ my: 2 }} />
      <Typography variant="h5" gutterBottom>
        5. Your Rights
      </Typography>
      <List>
        <ListItem><ListItemText primary="Access" secondary="Request a copy of the data we hold about you." /></ListItem>
        <ListItem><ListItemText primary="Correction" secondary="Update or correct inaccuracies in your data." /></ListItem>
        <ListItem><ListItemText primary="Deletion" secondary="Request deletion of your data, subject to applicable legal obligations." /></ListItem>
      </List>
      
      <Divider sx={{ my: 2 }} />
      <Typography variant="h5" gutterBottom>
        6. Contact Us
      </Typography>
      <Typography variant="body1" paragraph>
        If you have any questions or concerns, please contact us at:
      </Typography>
      <Typography variant="body1"><strong>Keel Info Solution</strong></Typography>
      <Typography variant="body1">Email: info@keelis.com</Typography>
      <Typography variant="body1">Phone: +91 44 222 99 222</Typography>
    </Container>
  );
};

export default PrivacyPolicy;